import Box from '@mui/material/Box';
import GenericPopupModal from 'components/GenericPopupModal/GenericPopupModal';
import { useAppDispatch, useAppSelector } from 'hooks';
import {
  selectInteractiveEmailDeflectionFeedback,
  selectWorkflowsConfig,
  setInteractiveEmailDeflectionFeedback,
} from 'reducers/workflows';
import { OrgThemedButton } from 'components/OrgThemedButton';
import useSubmitInteractiveEmailDeflectionFeedback from './hooks/useSubmitInteractiveEmailDeflectionFeedback';

interface EndInteractiveEmailChatModelProps {
  isDeflected?: boolean;
  isOpen?: boolean;
  onClose: () => void;
}

export const EndInteractiveEmailChatModalGlobal = () => {
  const dispatch = useAppDispatch();
  const interactiveEmailDeflectionFeedback = useAppSelector(
    selectInteractiveEmailDeflectionFeedback,
  );
  const isDeflected = interactiveEmailDeflectionFeedback === 'deflected';

  const isOpen = Boolean(interactiveEmailDeflectionFeedback);

  return (
    <EndInteractiveEmailChatModal
      isDeflected={isDeflected}
      isOpen={isOpen}
      onClose={() => dispatch(setInteractiveEmailDeflectionFeedback(null))}
    />
  );
};

const EndInteractiveEmailChatModal = ({
  isDeflected = false,
  isOpen = false,
  onClose,
}: EndInteractiveEmailChatModelProps) => {
  const { interactive_email_static_text: staticText } =
    useAppSelector(selectWorkflowsConfig) ?? {};
  const { isLoading, onSubmit } = useSubmitInteractiveEmailDeflectionFeedback({
    isDeflected,
  });

  if (!staticText) {
    return null;
  }

  return (
    <GenericPopupModal
      content={staticText?.end_chat_description}
      footer={
        <Box display='flex' gap={1} width='100%'>
          <OrgThemedButton fullWidth onClick={onClose} variant='outlined'>
            {staticText?.cancel}
          </OrgThemedButton>
          <OrgThemedButton fullWidth onClick={onSubmit} variant='contained'>
            {staticText?.end_chat}
          </OrgThemedButton>
        </Box>
      }
      isLoading={isLoading}
      isOpen={isOpen}
      onClose={onClose}
      title={staticText?.end_chat}
    />
  );
};
